module.exports = __webpack_public_path__ + "img/dcopslogo3.1eb97730.png";